import React from 'react';

const TONES = new Set(['success', 'warning', 'danger', 'info', 'neutral']);

/**
 * 種別共通のステータスpill。tone で色が決まる（同意=success / 回答待ち=warning / 中止=danger ...）。
 */
export default function StatusBadge({ tone = 'neutral', icon, lg = false, children, className = '' }) {
  const t = TONES.has(tone) ? tone : 'neutral';
  return (
    <span
      className={`detail-status detail-status--${t}${lg ? ' detail-status--lg' : ''}${className ? ` ${className}` : ''}`}
    >
      {icon ? <i className={icon} aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
